import { render, staticRenderFns } from "./GRCListTable.vue?vue&type=template&id=e08acbec&scoped=true&"
import script from "./GRCListTable.vue?vue&type=script&lang=js&"
export * from "./GRCListTable.vue?vue&type=script&lang=js&"
import style0 from "./GRCListTable.vue?vue&type=style&index=0&id=e08acbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08acbec",
  null
  
)

export default component.exports